import { useLocation } from '../../app/route';
import {
  deserializeRoleId,
} from './roleSlice';

export function useQueryRoleId() {
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const role_id = deserializeRoleId(query.get('role_id') ?? '');
  return role_id;
}
